import { Component, Output, EventEmitter, Input } from '@angular/core';

import { HisNavigationService, HisNotificationService, HisUiService, HisAuthService, HisGlobalDataService } from 'hisng';

import {
    DATA_SERVICE_KEY_PUBLICATION,
    DATA_SERVICE_KEY_JOURNAL,
    DATA_SERVICE_KEY_CHILD_PUBLICATION
} from 'app/fs/res/publication/model/constants';
import { PublisherService } from 'app/fs/res/publication/service/publisher.service';
import { Publication } from 'app/fs/res/publication/model/publication';
import { Publisher } from 'app/fs/res/publication/model/publisher';
import { Journal } from 'app/fs/res/publication/model/journal';
import { PublisherModuleOptions } from '../publisher-module.options';

@Component({
    selector: 'res-publisher-plam',
    templateUrl: './publisher-plam.component.html',
})
export class PublisherPlamComponent {

    public readonly moduleOptions = PublisherModuleOptions;

    @Input('publisher') set publisherData(p: Publisher) {
        this.publisher = {...p};
    }
    @Input() journal: Journal;
    @Input() publication: Publication;
    @Input() childPublication: Publication;
    @Input() dDKey = '';
    @Output() publisherChange = new EventEmitter<Publisher>();
    @Output() navigationLastUrlChange = new EventEmitter<string>();

    publisher: Publisher;
    public filteredPublishers: Publisher[];

    constructor(public auth: HisAuthService,
        private publisherService: PublisherService,
        private navigationService: HisNavigationService,
        private notificationService: HisNotificationService,
        public hisUiService: HisUiService,
        private globalDataService: HisGlobalDataService) {
    }

    // autocomplete function
    public filterPublisher(event: { query: string }) {
        this.publisherService.getWrappedPublishers(event.query).subscribe( (publishers: Publisher[]) => {
            this.filteredPublishers = publishers;
        });
    }

    // manipulation methods
    public addPublisher() {
        if (!this.publisher) {
            this.notificationService.errorI18nRes('fs.res.publication.publisher.noAssignPublisher');
        } else {
            this.publisherChange.emit(this.publisher);
        }
    }

    /* leaving page action use onBeforeNavigate set current objects to globalDataService */
    public onBeforeNavigate() {
        this.navigationLastUrlChange.emit( window.location.href );

        if (this.journal) {
            this.globalDataService.setData(DATA_SERVICE_KEY_JOURNAL, this.journal);
            this.navigationService.stopDirtyTracking();
        }
        if (this.publication) {
            this.globalDataService.setData(DATA_SERVICE_KEY_PUBLICATION, this.publication);
            this.navigationService.stopDirtyTracking();
        }
        if (this.childPublication) {
            this.globalDataService.setData(DATA_SERVICE_KEY_CHILD_PUBLICATION, this.childPublication);
            this.navigationService.stopDirtyTracking();
        }
    }

    public onClear() {
        this.publisher = null;
        this.publisherChange.emit(null);
    }
}
